export const jessica = {
  setText: (text: string) => {
    try {
      const cmp = window.AiAgentsWebWidget?.getComponent?.('transcribe');
      cmp?.api?.onPaste?.(text);
    } catch {
      return '';
    }
  },
  getText: () => {
    try {
      const cmp = window.AiAgentsWebWidget?.getComponent?.('transcribe');
      return cmp?.api?.getText?.() || '';
    } catch {
      return '';
    }
  },
};
